import script from "./PointsCreditWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsCreditWidget.vue?vue&type=script&setup=true&lang=js"

import "./PointsCreditWidget.vue?vue&type=style&index=0&id=fb5dc7d4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb5dc7d4"]])

export default __exports__